// src/plugins/fake-api/handlers/auth/db.js
export const db = {
  users: [
    {
      id: 1,
      email: 'admin@salubris.au',
      password: 'admin',
      fullName: 'Administrator',
      username: 'admin',
      role: 'admin',
      avatar: null,
      abilityRules: [
        {
          action: 'manage',
          subject: 'all',
        },
      ],
    },
    {
      id: 2,
      email: 'client@salubris.au',
      password: 'client',
      fullName: 'Traditional Owner Partner',
      username: 'client',
      role: 'client',
      avatar: null,
      abilityRules: [
        {
          action: 'read',
          subject: 'dashboard',
        },
        {
          action: 'read',
          subject: 'assets',
        },
        {
          action: 'read',
          subject: 'carbon-credits',
        },
      ],
    },
  ],
  userTokens: {
    1: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiZW1haWwiOiJhZG1pbkBzYWx1YnJpcy5hdSIsInJvbGUiOiJhZG1pbiJ9',
    2: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MiwiZW1haWwiOiJjbGllbnRAc2FsdWJyaXMuYXUiLCJyb2xlIjoiY2xpZW50In0',
  },
}
